var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section breadcrumb-section"},[_c('div',{staticClass:"container is-max-hd"},[_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }